import { Modal } from '@seiue/ui'
import { StepsProps } from 'antd'
import { CSSProperties, FC, ReactNode } from 'react'
import styled from 'styled-components'

import { Steps } from 'packages/components/ThemeComponents'

/**
 * 编辑活动全屏弹窗 Layout
 *
 * @param param0 - 参数
 * @param param0.content - 内容
 * @param param0.title - 标题
 * @param param0.onClose - 关闭回调
 * @param param0.headerRight - 右侧内容
 * @param param0.stepsParams - 步骤条参数
 * @param param0.style - 样式
 * @param param0.contentStyle - 内容样式
 * @param param0.hiddenHeader - 是否隐藏头部
 * @returns 组件
 */
export const ModalLayout: FC<{
  content: ReactNode
  title?: ReactNode
  onClose?: () => void
  headerRight?: ReactNode
  stepsParams?: StepsProps
  style?: CSSProperties
  contentStyle?: CSSProperties
  hiddenHeader?: boolean
}> = ({
  onClose,
  title,
  headerRight,
  stepsParams,
  content,
  style,
  contentStyle,
  hiddenHeader,
}) => {
  return (
    <ModalWrapper style={style}>
      {hiddenHeader ? null : (
        <Modal.Header
          title={title}
          onClose={onClose}
          style={{
            backgroundColor: '#fff',
            boxShadow: 'inset 0px -1px 0px 0px #e1ebf0',
            padding: '20px 24px',
            height: '64px',
          }}
          headerRight={headerRight}
        />
      )}
      {stepsParams ? (
        <StepWrapper>
          <Steps
            responsive={false}
            style={{
              margin: '0 auto',
              width: '408px',
              boxShadow: 'none',
            }}
            size="small"
            {...stepsParams}
          />
        </StepWrapper>
      ) : null}
      <ModalContent
        $hasSteps={!!stepsParams}
        style={contentStyle}
      >
        {content}
      </ModalContent>
    </ModalWrapper>
  )
}

const ModalWrapper = styled.div`
  min-width: 1000px;
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  overflow: hidden;
  &&& {
    .ant-steps {
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: inset 0px -1px 0px 0px #e5e6e8;
    }
  }
`

const ModalContent = styled.div<{ $hasSteps: boolean }>`
  background-color: ${(props) => props.theme.background._3};
  padding: 20px;
  min-height: calc(100vh - ${(props) => (props.$hasSteps ? '121px' : '64px')});
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  flex: 1;
`

const StepWrapper = styled.div`
  min-width: 960px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  box-shadow: 0px 0px 1px 0px rgba(21, 29, 41, 0.2),
    0px 3px 8px -1px rgba(21, 29, 41, 0.04);
  z-index: 1;
`
